import _ from 'lodash';
import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import {
    AddComparePatent,
    CoreSearchApiService,
    FetchCompareInit,
    GetCompareList,
    GetCompareOverview, GetComparePatentText,
    GetCompareText,
    SearchComparePatent,
    SearchSettingLanguage,
    TranslateSpecificField,
} from '@/infrastructure/api-functions/core-search-api/core-search-api';
import { CoreSearchApiServiceImpl } from '@/infrastructure/api-functions/core-search-api/impls/core-search-api';
import { TranslateConfigService, TranslateService } from '@/services/translation/translate-service.interface';
import { TranslateServiceImpl } from '@/services/translation/translate-service';
import { GetPatentBasic } from '@/infrastructure/api-functions/core-search-api/get-patent-basic-api';
import { GetPatentInitTab } from '@/infrastructure/api-functions/core-search-api/get-patent-init-tab-api';
import { GetPatentTemplate } from '@/infrastructure/api-functions/core-search-api/get-patent-template-api';
import { GetPatentValuation } from '@/infrastructure/api-functions/core-search-api/get-patent-valuation-api';
import { GetPatentViewInit } from '@/infrastructure/api-functions/core-search-api/patent-view-init-api';
import { GetClaimFeature } from '@/infrastructure/api-functions/core-search-api/get-claim-feature-api';
import { GetClaimCompareMatch } from '@/infrastructure/api-functions/core-search-api/get-claim-compare-match-api';
import { GetResultPosition } from '@/infrastructure/api-functions/core-search-api/get-result-position-api';
import { GetClaimCompareTranslation } from '@/infrastructure/api-functions/core-search-api/get-claim-compare-translation-api';
import { GetClaimCompareExport } from '@/infrastructure/api-functions/core-search-api/get-claim-compare-export-api';
import { SetClaimCompareTranslationCache } from '@/infrastructure/api-functions/core-search-api/get-claim-compare-translation-cache-api';
import { CoreBasicApiServiceImpl } from '@/infrastructure/api-functions/core-search-api/impls/core-basic-api';
import { GetClaimCompareResult } from '@/infrastructure/api-functions/core-search-api/get-claim-compare-result-api';
import { GetPatentPum } from '@/infrastructure/api-functions/core-search-api/get-patent-pum-api';

export const serviceApiModule = new ContainerModule((bind) => {
    bind(CoreSearchApiService).to(CoreSearchApiServiceImpl);
    bind(TranslateSpecificField).to(CoreSearchApiServiceImpl);
    bind(SearchSettingLanguage).to(CoreSearchApiServiceImpl);
    bind(FetchCompareInit).to(CoreSearchApiServiceImpl);
    bind(GetCompareList).to(CoreSearchApiServiceImpl);
    bind(GetCompareOverview).to(CoreSearchApiServiceImpl);
    bind(GetCompareText).to(CoreSearchApiServiceImpl);
    bind(SearchComparePatent).to(CoreSearchApiServiceImpl);
    bind(AddComparePatent).to(CoreSearchApiServiceImpl);
    bind(GetComparePatentText).to(CoreSearchApiServiceImpl);
    bind(TranslateService).to(TranslateServiceImpl);
    bind(TranslateConfigService).to(TranslateServiceImpl);
    bind(GetPatentBasic).to(CoreSearchApiServiceImpl);
    bind(GetPatentInitTab).to(CoreSearchApiServiceImpl);
    bind(GetPatentTemplate).toDynamicValue(() => ({
        getPatentTemplate: async () => {
            const tplLinks: Record<string, string> = _.get(window, 'zPREFACE.tplLinks', {}) as Record<string, string>;
            return {
                EPONEW: tplLinks.EPONEW,
                USA: tplLinks.USA,
                USB: tplLinks.USB,
                UST: tplLinks.UST,
                DE: tplLinks.DE,
                EM: tplLinks.EM,
                NO: tplLinks.NO,
                CN: tplLinks.CN,
                CAA: tplLinks.CAA,
                CAB: tplLinks.CAB,
                CAD: tplLinks.CAD,
                AU: tplLinks.AU,
                WO: tplLinks.WO,
                INPADOC: tplLinks.INPADOC,
            };
        },
    }));
    bind(GetPatentValuation).to(CoreSearchApiServiceImpl);
    bind(GetPatentViewInit).to(CoreSearchApiServiceImpl);
    bind(GetClaimFeature).to(CoreSearchApiServiceImpl);
    bind(GetClaimCompareMatch).to(CoreSearchApiServiceImpl);
    bind(GetResultPosition).to(CoreSearchApiServiceImpl);
    bind(GetClaimCompareTranslation).to(CoreSearchApiServiceImpl);
    bind(GetClaimCompareExport).to(CoreBasicApiServiceImpl);
    bind(SetClaimCompareTranslationCache).to(CoreSearchApiServiceImpl);
    bind(GetClaimCompareResult).to(CoreSearchApiServiceImpl);
    bind(GetPatentPum).to(CoreSearchApiServiceImpl);
});
